import { executeHttpRequest } from '../infra/HttpClient';
import TargetsApi from '../api/TargetsApi';

export async function getDynamicTrends(url) {
  return executeHttpRequest(TargetsApi.getDynamicTrends(url));
}
